import { Actions, ActionTypes } from './actions';
import { adapter, initialState, SelfDiagnosticStepState } from './state';

export function reducer(state = initialState, action: Actions): SelfDiagnosticStepState {
  switch (action.type) {
    case ActionTypes.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case ActionTypes.GET_STEP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ActionTypes.GET_STEP_SUCCESS:
      return adapter.setOne(action.item, {
        ...state,
        isLoading: false,
        error: null,
        selected: { ...action.item },
      });

    case ActionTypes.SET_SELECTED_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.SET_SELECTED_SUCCESS: {
      return {
        ...state,
        selected: action.model ? { ...action.model } : null,
        isLoading: false,
        error: null,
      };
    }

    default:
      return state;
  }
}
